export enum ProductSelectorMode {
  SIMPLE,
  TOUCH
}
